// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Deal } from '@interfaces/deal.interfaces';
import { BuyerRoutes } from '@interfaces/user.interfaces';
import { Vehicle } from '@interfaces/vehicle.interfaces';
import { DocumentsService } from '@services/documents.service';
import { getImage, showMissingImage } from 'src/app/utils/utils';

@Component({
    selector: 'buyer-deal-card',
    templateUrl: './buyer-deal-card.component.html',
    styleUrls: ['./buyer-deal-card.component.scss'],
})
export class BuyerDealCardComponent implements OnInit {
    @Input() deal: Deal = null;

    vehicleImage: string | null = null;

    constructor(private readonly router: Router) {}

    ngOnInit(): void {
        this.getVehicleImage();
    }

    public async getVehicleImage(): Promise<any> {
        await getImage(this.deal).then((image) => {
            if (image.includes('https') || image.includes('assets/')) {
                this.vehicleImage = image;
            } else {
                this.vehicleImage = 'data:image/webp;base64, ' + image;
            }
        });
    }

    public redirect(event: any, route: number): void {
        event.stopPropagation();

        route === BuyerRoutes.deal
            ? this.router.navigate(['/main', 'vehicles', this.deal.dealId])
            : this.router.navigate(['/main', 'vehicles', this.deal.dealId, 'info']);
    }

    public showMissingImage($event): any {
        showMissingImage($event);
    }
}
